/** Saves a fetched blob as a file (CSV / transcript exports from the API). */
export function saveBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.rel = "noopener";
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}

/** `stem-2026-10-11.ext` filename for exports. */
export function datedFilename(stem: string, extension: string, now = new Date()): string {
  return `${stem}-${now.toISOString().slice(0, 10)}.${extension}`;
}
